 <template>
  <div id="app" :style="{ paddingTop: showGuide ? '1.866667rem' : '0' }">
    <common-header v-if="showGuide"></common-header>
    <van-popup
      class="srcreen"
      v-model="showDialog"
      :close-on-click-overlay="false"
    >
      <div class="first-img">
        <div></div>
        <div>
          <img
            @click="to"
            class="close-icon"
            src="@/assets/scrrenClose.png"
            alt=""
          />
        </div>
      </div>
      <div class="title">
        <div class="header-asa">
          <span class="span">Your screen is detected to be rotating</span>
        </div>
      </div>
      <div class="screen-content">
        <p>Please turn on "Portrait Orientation Lock"</p>
        <div class="other">
          <img class="screen" src="@/assets/mask.png" alt="" />
          <span>in the Control Center before taking a photo.</span>
        </div>
      </div>
      <common-btn class="consult" :click="to">Consult The Index</common-btn>
    </van-popup>
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDialog: false
    }
  },
  beforeDestroy () {
    window.removeEventListener(
      'orientationchange',
      this.handleOrientationChange
    )
  },
  mounted () {
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  computed: {
    showGuide () {
      // 有的页面本身是不需要显示的 在此添加
      const noshow = ['RefuseRegisterPage', 'InReview', 'LoanSuccess', 'ScrrenGuide', 'Base', 'Facial', 'PhotoLiving']
      return !noshow.includes(this.$route.name)
    }
  },
  created () {
    const adjustTimer = setInterval(() => {
      // eslint-disable-next-line no-undef
      const res = Adjust.getAttribution()
      if (res && res.adid) {
        if (!localStorage.getItem('adid')) {
          localStorage.setItem('adid', res.adid)
        }
        if (!localStorage.getItem('First_Open_Event')) {
          this.$adjustTrack({
            event_token: process.env.VUE_APP_ADJUST_FIRST_OPEN_EVENT_TOKEN,
            data: {}
          })
          localStorage.setItem('First_Open_Event', 1)
        }
        clearInterval(adjustTimer)
      } else {
      }
    }, 1000)
  },
  methods: {
    handleOrientationChange () {
      const that = this
      if (window.orientation === 90 || window.orientation === -90) {
        const noshow = ['PhotoLiving']
        if (noshow.includes(that.$route.name)) {
          this.$eventTrack({
            // eslint-disable-next-line eqeqeq
            pageName: 'VerifyFacial-refused',
            action: 'Camera_Guide'
          })
          this.showDialog = true
        }
      } else {
        this.showDialog = false
      }
    },
    close () {
      this.showDialog = false
    },
    to () {
      this.$router.replace({ name: 'Facial' })
      this.showDialog = false
    }
  }
}
</script>
<style lang="less" scoped>
#app {
  font-family: Inter, Inter;
  font-style: normal;
  text-align: center;
  color: #2c3e50;
  ::v-deep .srcreen.van-popup {
    width: 55%;
    padding: 0.3rem;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    color: #12033a;
    .close-icon {
      width: 12px;
    }
    .screen-content {
      padding: 0 10px;
      text-align: left;
      margin-top: 10px;
      p,
      span {
        font-weight: 600;
        font-size: 0.25rem !important;
      }
    }
    .other {
      display: flex;
    }
    .title {
      font-size: 0.25rem;
    }
    .first-img {
      margin-top: -8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .screen {
    width: 28px;
    margin-right: 7px;
    height: 28px;
    margin-top: 3px;
  }
  .header-asa {
    width: 100%;
    text-align: center;
    .span {
      width: 70%;
      font-size: 11px;
    }
  }
  .consult {
    font-size: 0.25rem;
    padding: 5px 0;
    margin-top: 10px;
  }
}
</style>
